import { Injectable } from '@angular/core';
import { fillArr } from '@pin-up-global/common';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { delay, Observable, of } from 'rxjs';
import { FeedbackRow, FeedbacksReq } from './feedbacks.abstraction';
import { FeedbackStatus } from '@root/pages/feedback';

@Injectable()
export class FeedbacksApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getFeedbacks(params: FeedbacksReq): Observable<ListResponse<FeedbackRow>> {
    return of({
      items: fillArr(params.limit!, (id) => ({
        id,
        botId: params.botId,
        status:
          id % 3 === 0
            ? FeedbackStatus.InProgress
            : id % 2 === 0
            ? FeedbackStatus.New
            : FeedbackStatus.Processed,
        receivedAt: new Date().toISOString(),
        botUser: {
          id: 1,
          firstName: 'Bot',
          lastName: `User ${id * params.page!}`,
        },
      })),
      count: 100,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  archiveFeedback(id: number): Observable<boolean> {
    return of(true).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }
}
